import React from "react";
import ceo from "../assets/ceo1.jpeg";
import "../styles/Ceo.css";
import img1 from "../assets/ceoo0.jpeg";
import img2 from "../assets/ceoo1.jpeg";
import img3 from "../assets/ceoo2.jpeg";
import img4 from "../assets/ceo3.jpeg";
const images = [
  { src: img1, title: "Technology", number: "01" },
  { src: img2, title: "Innovation", number: "02" },
  { src: img3, title: "Digital Solutions", number: "03" },
  { src: img4, title: "Future Ready", number: "04" },

  // Example for future images:
  // { src: img5, title: "Cloud", number: "05" },
  // { src: img6, title: "Artificial Intelligence", number: "06" },
];

function CEO() {
  return (
    <div className="ceo-page">

      {/* =====================================================
          HERO
      ===================================================== */}
      <section className="ceo-hero">

        <div className="ceo-hero-grid"></div>
        <div className="ceo-glow ceo-glow-one"></div>
        <div className="ceo-glow ceo-glow-two"></div>

        <div className="ceo-container">

          <div className="ceo-image-wrap">

            <div className="ceo-image-orbit orbit-one"></div>
            <div className="ceo-image-orbit orbit-two"></div>

            <div className="ceo-image-frame">
              <div className="ceo-image-shine"></div>

              <img
                src={ceo}
                alt="Nagulmeera Shaik"
                className="CEO1"
              />
            </div>

            <div className="ceo-floating-card card-top">
              <span>01</span>
              <small>Founder</small>
            </div>

            <div className="ceo-floating-card card-bottom">
              <span className="status-dot"></span>
              <small>CEO</small>
            </div>

          </div>

          <div className="ceo-content">

            <div className="section-number">
              <span>01</span>
              <i></i>
              <small>EXECUTIVE LEADERSHIP</small>
            </div>

            <div className="ceo-eyebrow">
              FOUNDER & MANAGING DIRECTOR
            </div>

            <h1>
              Nagulmeera
              <span>Shaik</span>
            </h1>

            <h2>
              Founder & Managing Director
              <strong>Techlynx Innovations Private Limited</strong>
            </h2>

            <div className="ceo-line"></div>

            <h3>
              “From Ideas to Impact – Driven by Technology.”
            </h3>

            <p>
              Nagulmeera Shaik is the Founder and Managing Director of
              Techlynx Innovations Private Limited, a technology-driven
              organization focused on connecting technology, talent,
              education, and industry opportunities.
            </p>

            <p>
              With experience across HR, recruitment, education, training,
              and business development, his approach brings together
              people management, technology, and organizational development.
            </p>

            <div className="ceo-highlight-row">
              <div>
                <strong>PEOPLE</strong>
                <span>Talent & Growth</span>
              </div>

              <div>
                <strong>TECH</strong>
                <span>Innovation & Solutions</span>
              </div>

              <div>
                <strong>IMPACT</strong>
                <span>Purpose & Progress</span>
              </div>
            </div>

          </div>

        </div>

        <div className="scroll-indicator">
          <span></span>
          <small>SCROLL TO EXPLORE</small>
        </div>

      </section>


      {/* =====================================================
          LEADERSHIP PHILOSOPHY
      ===================================================== */}
      <section className="ceo-premium-section leadership-section">

        <div className="section-bg-number">02</div>

        <div className="ceo-section-inner">

          <div className="section-intro">
            <span className="section-tag">02 — LEADERSHIP</span>

            <h2 className="ce">
              Leadership <span>with Purpose.</span>
            </h2>

            <div className="section-line"></div>
          </div>

          <div className="section-content-grid">

            <div className="section-main-copy">

              <p className="large-copy">
                Leadership is viewed as a continuous responsibility to
                develop people, strengthen skills, embrace technology,
                and create sustainable growth.
              </p>

              <p>
                His leadership philosophy focuses on people, skills,
                technology, discipline, communication, practical exposure,
                and continuous learning.
              </p>

              <p>
                Effective leadership requires responsibility and the
                willingness to continuously improve while creating an
                environment where individuals can contribute and grow.
              </p>

            </div>

            <div className="philosophy-card">

              <div className="quote-mark">“</div>

              <blockquote>
                Technology creates possibilities,
                <span>but people create impact.</span>
              </blockquote>

              <div className="quote-line"></div>

              <small>
                LEADERSHIP PHILOSOPHY
              </small>

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          BUILDING TECHLYNX
      ===================================================== */}
      <section className="ceo-premium-section dark-section">

        <div className="tech-grid"></div>
        <div className="dark-glow"></div>

        <div className="section-bg-number">03</div>

        <div className="ceo-section-inner">

          <div className="section-intro">

            <span className="section-tag">
              03 — OUR JOURNEY
            </span>

            <h2>
              Building
              <span>Techlynx.</span>
            </h2>

            <div className="section-line"></div>

          </div>

          <div className="journey-layout">

            <div className="journey-number">
              <span>03</span>
              <div></div>
            </div>

            <div className="journey-copy">

              <p className="large-copy">
                Techlynx Innovations is being developed as a technology
                ecosystem where software, talent, education, and industry
                can come together.
              </p>

              <p>
                The organization works with students, freshers, experienced
                professionals, institutions, clients, and industry partners.
              </p>

              <p>
                Its activities include software services, technology
                initiatives, recruitment and manpower support, internships,
                academic-industry programs, projects, workshops, training,
                and collaborations.
              </p>

            </div>

            <div className="journey-points">

              <div className="journey-point">
                <span>01</span>
                <strong>Technology</strong>
                <small>Software & Digital Solutions</small>
              </div>

              <div className="journey-point">
                <span>02</span>
                <strong>Talent</strong>
                <small>Skills & Opportunities</small>
              </div>

              <div className="journey-point">
                <span>03</span>
                <strong>Education</strong>
                <small>Learning & Exposure</small>
              </div>

              <div className="journey-point">
                <span>04</span>
                <strong>Industry</strong>
                <small>Partnerships & Collaboration</small>
              </div>

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          PEOPLE FIRST
      ===================================================== */}
      <section className="ceo-premium-section people-section">

        <div className="section-bg-number">04</div>

        <div className="ceo-section-inner">

          <div className="people-layout">

            <div className="people-copy">

              <span className="section-tag">
                04 — PEOPLE FIRST
              </span>

              <h2>
                A People-First <span> Technology Vision.</span>
              </h2>

              <div className="section-line"></div>

              <p className="large-copy">
                People remain at the center of the technology vision.
              </p>

              <p id="para">
                The goal is to create an environment where individuals
                receive opportunity, guidance, practical exposure, and
                the right platform to develop their capabilities.
              </p>

              <p id="para">
                Technology becomes meaningful when it helps people learn,
                grow, collaborate, and create solutions with real-world
                value.
              </p>

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          EDUCATION + INDUSTRY
      ===================================================== */}
      <section className="ceo-premium-section education-section dark-section">

        <div className="tech-grid"></div>

        <div className="section-bg-number">05</div>

        <div className="ceo-section-inner">

          <div className="education-header">

            <span className="section-tag">
              05 — EDUCATION & INDUSTRY
            </span>

            <h2>
              Connecting Education
              <span>with Industry.</span>
            </h2>

            <p>
              Creating meaningful bridges between academic learning,
              professional exposure, and real-world industry requirements.
            </p>

          </div>

          <div className="connection-system">

            <div className="connection-item">
              <div className="connection-icon">01</div>
              <h3>Students</h3>
              <p>Practical learning and professional exposure.</p>
            </div>

            <div className="connection-line"></div>

            <div className="connection-item">
              <div className="connection-icon">02</div>
              <h3>Institutions</h3>
              <p>Academic-industry collaboration and development.</p>
            </div>

            <div className="connection-line"></div>

            <div className="connection-item">
              <div className="connection-icon">03</div>
              <h3>Industry</h3>
              <p>Recruitment, projects, partnerships, and opportunities.</p>
            </div>

          </div>

          <div className="education-copy">

            <p>
              Colleges, students, recruiters, technology professionals,
              and organizations can work together through practical
              learning, internships, projects, recruitment, and
              industry-focused development.
            </p>

          </div>

        </div>
      </section>


      {/* =====================================================
          FUTURE VISION
      ===================================================== */}
      <section className="future-section">

        <div className="future-orb orb-one"></div>
        <div className="future-orb orb-two"></div>

        <div className="future-grid"></div>

        <div className="future-content">

          <span className="section-tag">
            06 — THE FUTURE
          </span>

          <div className="future-number">06</div>

          <h2>
            Vision <span> for the Future.</span>
          </h2>

          <div className="future-line"></div>

          <p>
            The future vision is centered around innovative products,
            reliable software services, skilled talent, and meaningful
            partnerships.
          </p>

          <p>
            As technology and business requirements continue to evolve,
            Techlynx Innovations aims to encourage innovation, responsible
            leadership, continuous learning, collaboration, and strong
            execution.
          </p>

          <div className="future-pillars">

            <span>INNOVATION</span>
            <span>LEARNING</span>
            <span>COLLABORATION</span>
            <span>EXECUTION</span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL LEADERSHIP MESSAGE
      ===================================================== */}
      <section className="ceo-message">

        <div className="message-grid"></div>

        <div className="message-orb message-orb-one"></div>
        <div className="message-orb message-orb-two"></div>

        <div className="message-content">

          <span className="section-tag">
            07 — LEADERSHIP MESSAGE
          </span>

          <div className="message-number">07</div>

          <h2>
            Building More Than
            <span>a Technology Company.</span>
          </h2>

          <div className="message-divider"></div>

          <blockquote>
            “Our journey is not only about building a technology company.
            It is about building an ecosystem where ideas can become
            solutions, skills can become opportunities, and people can
            become the driving force behind meaningful technology.”
          </blockquote>

          <div className="ceo-signature">

            <div className="signature-line"></div>

            <strong>Nagulmeera Shaik</strong>

            <span>Founder & Managing Director</span>

            <span>Techlynx Innovations Private Limited</span>

            <small>
              From Ideas to Impact – Driven by Technology.
            </small>

          </div>

        </div>

      </section>
      <section className="horizontal-image-section">
      <div className="horizontal-image-header">
        <div>
          <span className="horizontal-eyebrow">TECHLYNX / EXPERIENCE</span>

          <h2>
            Built for the
            <span> Future.</span>
          </h2>
        </div>

        <p>
          Explore our technology, people and digital experiences through a
          continuously moving visual showcase.
        </p>
      </div>

      <div className="horizontal-image-wrapper">
        <div className="horizontal-image-track">
          {images.map((image, index) => (
            <article
              className="horizontal-image-card"
              key={`${image.number}-${index}`}
            >
              <div className="horizontal-image-number">
                {image.number}
              </div>

              <div className="horizontal-image-frame">
                <img
                  src={image.src}
                  alt={image.title}
                  loading="lazy"
                />

                <div className="horizontal-image-overlay">
                  <span>{image.number}</span>
                  <h3>{image.title}</h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="horizontal-image-footer">
        <span>SCROLL TO EXPLORE</span>
        <div className="horizontal-line">
          <span></span>
        </div>
      </div>
    </section>

    </div>
  );
}

export default CEO;